import { render, staticRenderFns } from "./desertTomb.vue?vue&type=template&id=4838a9bc&"
import script from "./desertTomb.vue?vue&type=script&lang=js&"
export * from "./desertTomb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports